import React, { memo } from 'react';
import PropTypes from 'prop-types';

const MessagePencil = (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill={props.color}
    fillRule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.8999 3.92327C1.8999 3.5919 2.16853 3.32327 2.4999 3.32327H11.4999C11.8313 3.32327 12.0999 3.5919 12.0999 3.92327C12.0999 4.25464 11.8313 4.52327 11.4999 4.52327H3.0999V20.6862H17.6092V13.4996C17.6092 13.1683 17.8778 12.8996 18.2092 12.8996C18.5406 12.8996 18.8092 13.1683 18.8092 13.4996V21.2862C18.8092 21.6176 18.5406 21.8862 18.2092 21.8862H2.4999C2.16853 21.8862 1.8999 21.6176 1.8999 21.2862V3.92327Z"
      fill={props.color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3514 7.84802C16.5857 8.08233 16.5857 8.46223 16.3514 8.69655L8.8192 16.2288C8.58488 16.4631 8.20498 16.4631 7.97067 16.2288C7.73635 15.9944 7.73635 15.6145 7.97067 15.3802L15.5029 7.84802C15.7372 7.6137 16.1171 7.6137 16.3514 7.84802Z"
      fill={props.color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.0849 2.83306L21.4999 2.69962L21.4156 2.10557C21.6111 2.07781 21.8078 2.14805 21.9415 2.29338C22.0752 2.43871 22.1288 2.64053 22.0849 2.83306ZM17.9891 11.1434C19.4431 9.68909 20.4634 7.58935 21.115 5.90268C21.444 5.05094 21.6856 4.28717 21.845 3.73575C21.9249 3.45979 21.9843 3.23634 22.024 3.08087C22.0439 3.00312 22.0589 2.94231 22.069 2.90038L22.0805 2.85186L22.0836 2.83866L22.0849 2.83306C22.0849 2.83306 22.0849 2.83306 21.4999 2.69962C21.4156 2.10557 21.4156 2.10557 21.4156 2.10557L21.4124 2.10603L21.4053 2.10706L21.3798 2.11085C21.3578 2.11417 21.326 2.11906 21.2851 2.12561C21.2033 2.13871 21.0851 2.15844 20.936 2.18545C20.638 2.23943 20.2162 2.3226 19.7163 2.44004C18.7198 2.67413 17.398 3.04786 16.1249 3.60514C15.9482 3.68244 15.8195 3.8399 15.7789 4.02835L15.7781 4.03208L15.7736 4.05149C15.7694 4.06951 15.7627 4.0974 15.7535 4.13373C15.7349 4.2065 15.7062 4.31252 15.6667 4.44057C15.5872 4.69872 15.4669 5.03654 15.3026 5.36885C15.136 5.70584 14.9387 6.0071 14.7175 6.21718C14.7034 6.23059 14.6893 6.24353 14.6752 6.25599V5.20484C14.6752 4.87347 14.4066 4.60484 14.0752 4.60484C13.9939 4.60484 13.9164 4.621 13.8457 4.65027C13.7589 4.67556 13.6804 4.70963 13.6156 4.7412C13.5046 4.79537 13.3891 4.86486 13.2737 4.94298C13.0424 5.09956 12.7815 5.31132 12.5132 5.56234C11.9769 6.06408 11.3777 6.75371 10.8997 7.54285C10.4243 8.32764 10.0452 9.24973 10.0039 10.2066C9.96164 11.1872 10.2773 12.1712 11.1295 13.0211C11.8236 13.7149 12.8789 13.9387 14.0603 13.6484C15.2356 13.3595 16.5766 12.5602 17.9891 11.1434ZM13.4752 6.30918C13.4289 6.35019 13.3814 6.39337 13.333 6.43867C12.8642 6.87717 12.3389 7.48304 11.9261 8.16459C11.5106 8.85048 11.2323 9.57425 11.2028 10.2583C11.1743 10.9185 11.3743 11.5705 11.9771 12.1716C12.3 12.4945 12.8863 12.7012 13.7739 12.483C14.6676 12.2634 15.8235 11.6159 17.1394 10.296C18.4135 9.02188 19.3616 7.11126 19.9956 5.47023C20.2985 4.68611 20.5241 3.97894 20.6762 3.45766C20.4732 3.49915 20.2425 3.5491 19.9908 3.60824C19.1058 3.81614 17.9739 4.13446 16.8733 4.5906C16.8563 4.65145 16.8364 4.71973 16.8135 4.794C16.722 5.09084 16.5798 5.49302 16.3783 5.9007C16.179 6.30371 15.907 6.74243 15.5438 7.08735C15.1747 7.4379 14.6842 7.71476 14.0752 7.71476C13.7438 7.71476 13.4752 7.44613 13.4752 7.11476V6.30918Z"
      fill={props.color}
    />
  </svg>
);

MessagePencil.defaultProps = {
  color: '#033A6D',
  width: 24,
  height: 24,
};

MessagePencil.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

export default memo(MessagePencil);
